import React, { useEffect, useRef, useState } from "react";
import Globe from "react-globe.gl";
import { useTranslation } from "react-i18next";
import "./style.css";

export default function GlobeMap() {
  const { t, i18n } = useTranslation();
  const globeEl = useRef();
  const [dimensions, setDimensions] = useState({ width: 700, height: 500 });

  const lang = i18n.language;

  const cities = [
    { name: "New York", lat: 40.7128, lng: -74.006 },
    { name: "Amsterdam", lat: 52.3676, lng: 4.9041 },
    { name: "Turkey", lat: 38.9637, lng: 35.2433 },
    { name: "Kuwait", lat: 29.3759, lng: 47.9774 },
    { name: "Paris", lat: 48.8566, lng: 2.3522 },
    { name: "Washington", lat: 38.9072, lng: -77.0369 },
    { name: "London", lat: 51.5074, lng: -0.1278 },
  ];

  const gData = cities.map((city) => ({
    lat: city.lat,
    lng: city.lng,
    name: city.name,
    maxR: 1,
    propagationSpeed: 1,
    repeatPeriod: 10,
  }));

  const colorInterpolator = () => "#57AEED";

  useEffect(() => {
    const handleResize = () => {
      setDimensions(
        window.innerWidth <= 768
          ? { width: 350, height: 300 }
          : { width: 700, height: 500 }
      );
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (globeEl.current) {
      const controls = globeEl.current.controls();
      controls.autoRotate = true;
      controls.autoRotateSpeed = -3;
      controls.enableZoom = false;
    }
  }, []);

  // Get location data from translation
  const loc = t("ourlocation.locations", { returnObjects: true });

  const renderLocation = (location, className) => location ? (
    <div className={`${className} location`}>
      <span className="c-word-glow">
        <span className="o-icon -size-8 c-stats_dot"></span>
      </span>
      <p dangerouslySetInnerHTML={{ __html: `${location.name}<span>${location.address}</span>` }} />
    </div>
  ) : null;

  return (
    <div className={`new_map ${lang === "ar" ? "ltr" : ""}`}>
      {/* LEFT SIDE */}
      <div className="locations_detail left_side">
        {renderLocation(loc.netherland, "map_location_detail_4")}
        {renderLocation(loc.kuwait, "map_location_detail_5")}
        {renderLocation(loc.turkey, "map_location_detail_6")}
      </div>

      {/* Globe */}
      <Globe
        className="globe-container"
        ref={globeEl}
        height={dimensions.height}
        width={dimensions.width}
        backgroundColor="rgba(255, 100, 50, 0)"
        globeImageUrl="//unpkg.com/three-globe/example/img/earth-night.jpg"
        ringsData={gData}
        ringColor={colorInterpolator}
        ringMaxRadius={(d) => d.maxR}
        ringPropagationSpeed={(d) => d.propagationSpeed}
        ringRepeatPeriod={(d) => d.repeatPeriod}
      />

      {/* RIGHT SIDE */}
      <div className="locations_detail right_side">
        {renderLocation(loc.usa, "map_location_detail_1")}
        {renderLocation(loc.france, "map_location_detail_2")}
      </div>

      {/* MOBILE VIEW */}
      <div className="locations_detail_mobile_view">
        {renderLocation(loc.netherland, "map_location_detail_4")}
        {renderLocation(loc.turkey, "map_location_detail_5")}
        {renderLocation(loc.kuwait, "map_location_detail_6")}
        {renderLocation(loc.usa, "map_location_detail_1")}
        {renderLocation(loc.france, "map_location_detail_2")}
      </div>
    </div>
  );
}
